import { GoalDto } from '@/api/generated';
import { GenerateButtonText } from '@/pages/GoalsPage/components/StrategicPlanStyles';
import { useIsGenerateButtonVisible } from '@/store/onboardingStore';

import { ContinueButton, GenerateButton } from '../OnboardingStyles';

interface ContinueGenerateButtonProps {
  hasCalendar: boolean;
  handleContinue: () => void;
  goals: GoalDto[];
  generatePlan: () => void;
  isGenerating: boolean;
  generatedStrategicPlan: string | null;
  isGenerateError: boolean;
}

const ContinueGenerateButton = ({
  hasCalendar,
  handleContinue,
  goals,
  generatePlan,
  isGenerating,
  generatedStrategicPlan,
  isGenerateError
}: ContinueGenerateButtonProps) => {
  const isGenerateButtonVisible = useIsGenerateButtonVisible();

  const goalsTitles = goals
    .slice(0, 3)
    .map(goal => goal.title)
    .filter(Boolean) as string[];

  return (
    <>
      {isGenerateButtonVisible ? (
        <GenerateButton
          onClick={generatePlan}
          disabled={
            goalsTitles.length === 0 || isGenerating || isGenerateError || !!generatedStrategicPlan
          }
        >
          <GenerateButtonText>Generate strategic plan</GenerateButtonText>
        </GenerateButton>
      ) : (
        <ContinueButton disabled={!hasCalendar} onClick={handleContinue}>
          {generatedStrategicPlan ? "Let's Begin!" : 'Continue'}
        </ContinueButton>
      )}
    </>
  );
};

export default ContinueGenerateButton;
